import React from 'react';

import InputLabel from '../../widgets/input-label';

import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class SignatureFieldElement extends React.Component {
    render() {
        const {
            label,
            defaultValue,
            required
        } = this.props.data;

        let localization = new Localization(window.edlio.localizations);
        return (
            <div className='text input'>
                <header>
                    <InputLabel ref='label' placeholder={defaultValue ? defaultValue : label} label={localization.localize(label)} required={required} usePlaceholderLabel={false} />
                </header>
                <div style={{display: 'flex'}}>
                    <div style={{width: '30%', justifyContent:'flex-start', marginLeft: 0}} className="placeholder">
                        <span>{localization.localize('Name')}</span>
                    </div>
                    <div style={{width: '30%', justifyContent:'flex-start'}} className="placeholder">
                        <span>{localization.localize('Date')}</span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/signature.js